module.exports = __webpack_public_path__ + "static/media/icone-ampulheta.4e7ad967.svg";